import {getTestProps} from '@benchling/js-test-utils';
import PropTypes from 'prop-types';
import React from 'react';

interface FileListProps {
  children: React.ReactNode;
}

export default function FileList({children}: FileListProps): JSX.Element {
  return (
    <div className="files-list-wrapper">
      <table className="table table-bordered">
        <tbody className="file-list" {...getTestProps({component: 'FileList', element: 'root'})}>
          {children}
        </tbody>
      </table>
    </div>
  );
}

FileList.propTypes = {
  children: PropTypes.node,
};
